const days = require('../constants/days')
const isSameDay = require('../dates/is-same-day')
const withinOneWeekFromToday = require('../dates/within-one-week-from-today')

/**
 * Format location hours with holidays
 * @param {*} hours
 * @param {*} holidayHours
 */
const formatHolidayHours = (hours, holidayHours) => {
  const todayDate = new Date()
  const todayDay = todayDate.getDay()
  const hoursCopy = [...hours]

  for (let i = 0, len = holidayHours.length; i < len; i++) {
    const holidayDate = new Date(holidayHours[i].date)
    const holidayDay = holidayDate.getUTCDay()

    if (isSameDay(holidayDate, todayDate)) {
      const di = hoursCopy.findIndex(obj => obj.day === days[todayDay])
      hoursCopy[di].hours = holidayHours[i].hours
      hoursCopy[di].title = holidayHours[i].title
    } else if (withinOneWeekFromToday(holidayDate, todayDate)) {
      const di = hoursCopy.findIndex(obj => obj.day === days[holidayDay])
      hoursCopy[di].hours = holidayHours[i].hours
      hoursCopy[di].title = holidayHours[i].title
    }
  }
  return hoursCopy
}

module.exports = formatHolidayHours
